import React, {useEffect} from 'react';
import MateService from "../../../../services/MateService/MateService";
import AutomService from "../../../../services/AutomService/AutomService";
import {useNavigate} from "react-router-dom";
import {useSetRecoilState} from "recoil";
import {alertState} from "../../../../recoil-store/recoil-state";
import {useTranslation} from "react-i18next";

function NewAutom({typeId}) {
    const history = useNavigate();
    const setAlert = useSetRecoilState(alertState);

    const {t} = useTranslation();

    useEffect(() => {
        const GetMates = async () => {
            const response = await MateService.getAllMates();
            if (response?.status) {
                if (response.data.length > 0) {
                    response.data.forEach((mate) => {
                        if (mate.is_default_device) {
                            SubmitAutom(mate.id);
                        }
                    });
                } else {
                    history(`/`);
                }
            }
        };

        GetMates().then(r => r);
    }, []);

    const SubmitAutom = async (mateId) => {
        const now = new Date().getTime();
        let newAutomData = {
            name: 'autom_' + now,
            description: "",
            type_id: typeId,
            integration_type: "STANDARD",
            timeOut: 5000,
            mate_id: mateId,
            queue_enabled: false,
            qpool_id: ""
        };

        const response = await AutomService.postAutom(newAutomData);

        if (response.status) {
            history(`/automs/${response.id}/autom/edit`);
        } else {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTOMS.AUTOMS-ADDED-FAILED"),
                severity: response.status ? 'success' : 'error'
            }));
        }
    }

    return (
        <></>
    );
}

export default NewAutom;
